// ----------------------------------------------------------------------
// Home's three cards (Ready to analyse, Suggested, In progress):
//   below md             stacked, each full width
//   md up to 1279px      Ready to analyse | Suggested, In progress below at full width
//   1280px and up        one row of three
// A card's row columns follow its own width, which these layouts decide: a third of
// the page is narrow until the page is wide (THREE_UP_ROOMY).
// ----------------------------------------------------------------------

export const THREE_UP = '@media (min-width:1280px)'
export const THREE_UP_ROOMY = '@media (min-width:1680px)'

/**
 * sx for props whose value depends on the card's width:
 *   byCardWidth({ gridTemplateColumns: { base: { xs, md, ... }, three, roomy } })
 * `base` is a theme-breakpoint value (or a plain one) used below 1280px; `three`
 * applies from 1280px, `roomy` from 1680px (defaults to `base`'s lg value).
 */
export const byCardWidth = (props) => {
  const base = {}
  const three = {}
  const roomy = {}
  Object.entries(props).forEach(([prop, value]) => {
    base[prop] = value.base
    three[prop] = value.three
    const wide = value.roomy !== undefined ? value.roomy : value.base?.lg ?? value.base
    roomy[prop] = wide
  })
  return { ...base, [THREE_UP]: three, [THREE_UP_ROOMY]: roomy }
}
